import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import usePlatform from "../../../hooks/usePlatform"
import mobileFunnelEffect from "../../../assets/images/funnel/funnel_effect_mobile.png"
import funnelEffect from "../../../assets/images/funnel/funnel_effect.png"
import mobileFunnelEffectEn from "../../../assets/images/funnel/funnel_effect_mobile_en.png"
import funnelEffectEn from "../../../assets/images/funnel/funnel_effect_en.png"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#F1F4FF",
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      padding: "0 20px",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function FunnelEffect() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()

  // const { ref } = useScrollImpressionLog({
  //   message: "5. 개선 사항은 AB TEST 로",
  //   eventKey: `homepage_funnel_section_5_impression`,
  // })
  return (
    <div className={classes.root}>
      {lang === "ko" ? (
        <div className={classes.wrapper}>{<img src={isMobile ? mobileFunnelEffect : funnelEffect} />}</div>
      ) : (
        <div className={classes.wrapper}>{<img src={isMobile ? mobileFunnelEffectEn : funnelEffectEn} />}</div>
      )}
    </div>
  )
}
